import * as Yup from 'yup';
import { fields } from '@synergy/utils';

import { CustomerConditionsFormValues } from './models/customer-conditions-form-values';

const fieldNames = fields<CustomerConditionsFormValues>();

export const customerDetailConditionsValidationSchema = Yup.object().shape(
    {
        [fieldNames.isMember]: Yup.boolean(),
        [fieldNames.memberSince]: Yup.date()
            .nullable()
            .when('isMember', {
                is: true,
                then: Yup.date().typeError('app.error.required').required('app.error.required'),
            }),
        [fieldNames.discount]: Yup.number()
            .min(0, 'app.error.minZero')
            .max(100, 'app.error.maxHundred')
            .when(['base', 'bulk'], {
                is: (base: number, bulk: number) => base || bulk,
                then: Yup.number().required('app.error.required'),
            }),
        [fieldNames.base]: Yup.number()
            .min(0, 'app.error.minZero')
            .when(['discount', 'bulk'], {
                is: (discount: number, bulk: number) => discount || bulk,
                then: Yup.number().required('app.error.required'),
            }),
        [fieldNames.bulk]: Yup.number()
            .min(0, 'app.error.minZero')
            .when(['discount', 'base'], {
                is: (discount: number, base: number) => discount || base,
                then: Yup.number().required('app.error.required'),
            }),
        [fieldNames.taxRateId]: Yup.number().typeError('app.error.required').required('app.error.required'),
        [fieldNames.paymentTermId]: Yup.number().typeError('app.error.required').required('app.error.required'),
        [fieldNames.paymentMethod]: Yup.string().required('app.error.required'),
        [fieldNames.bonusPayout]: Yup.number().nullable().min(0, 'app.error.minZero'),
        [fieldNames.bonusBase]: Yup.number()
            .nullable()
            .when('isMember', {
                is: true,
                then: Yup.number().required('app.error.required').min(0, 'app.error.minZero'),
            }),

        [fieldNames.ledgerAccountId]: Yup.number()
            .nullable()
            .when('isMember', {
                is: true,
                then: Yup.number().typeError('app.error.required').required('app.error.required'),
            }),
    },
    [
        ['base', 'bulk'],
        ['discount', 'bulk'],
        ['discount', 'base'],
    ]
);
